<template>
  <div class="welcome">
    <el-collapse v-model="activeName" accordion style="width: 50%">
        <el-collapse-item :title="'版本号：'+item.versionNum + '  更新日期：' + item.updateNum" v-for="(item, index) in versionArr" :key="index" :name="index+1">
            <div class="content-box">
                <div style="flex: 1">
                    <div v-for="(child, index) in item.content" :key="index">{{child}}</div>
                </div>
                <div class="version-btn" v-if="item.src">
                    <a class="btn-box" :href="item.src" target="_blank">
                        <img class="btn-img" src="https://cargocnwebimage.oss-cn-beijing.aliyuncs.com/hhypc/examine.png" alt="" srcset="">
                        <div>查询详情文档</div>
                    </a>
                </div>
            </div>
        </el-collapse-item>
    </el-collapse>
    <div class="version-background">
        <img class="version-img" src="https://cargocnwebimage.oss-cn-beijing.aliyuncs.com/hhypc/versionBackground.png" alt="" srcset="">
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
        activeName: 1,
        versionArr: [
            {versionNum: 'hhy20230320', updateNum: '2023年03月20日', src:"https://hhy.cargocn.com/download/hhypdf/hhy-230320.pdf",content: ['1、用户在好货云平台操作的运单状态变更（起运、到达、关闭、删除等），将会即时同步至货运中国APP；','2、用户在好货云平台操作的运单指派变更（自主派车），将会同步至货运中国APP且会关联原有货源；','3、用户在好货云平台操作的货源模块相关（新建货源、编辑货源等），将会同步相关合同信息至货运中国APP，并做数据互通；','4、用户在好货云平台操作的发货管理模块新增外包运输功能，使用外包运输发布的货源即时关联货运中国APP，托运方、承运方、分包承运商均可查看相关信息；','5、用户在好货云平台操作的开票管理模块新增分包商和分包含税金额；']},
            {versionNum: 'hhy20210928', updateNum: '2021年09月28日', content: ['1、新增批导时校验车辆、司机必填是否缺失。如果缺失，则该条数据导入失败，请前往司机管理或者车辆管理中补齐数据后重新导入', '2、新增司机通过APP小程序接单，有未起运，到达运单，司机不能再次接单', '3、新增审核中心-增加受理人查询项', '4、新增绥德运单上报数据，接口字段调整', '5、修复财务管理-授信客户查询，查询明细按查询条件导出 ','6、新增连续登录三次密码错误后需要等待30分钟才能重试']},
            {versionNum: 'hhy20210915', updateNum: '2021年09月15日', src:'https://hhy.cargocn.com/download/hhypdf/hhy-0915.pdf', content: ['1、修复托运方对应多个承运方导出数据不准确的缺陷；', '2、新增版本更新目录页面', '3、修复移动端第一次扫码没有货源的缺陷', '4、新增资金账户-项目收支导出功能', '5、常用页面初始化速度优化','6、收款管理导出功能优化按模板导出；','7、运营端-司机支付流水报表-点重置关闭页面-再次打开还是保留原查询条件','8、货先生企业货源二维码需要可以支持微信识别图片二维码；','9、托运端-司机管理--新建--身份证存在时，提示已存在的手机号；','10、托运端-管理员账号看不到子账号建立的运单数据']},
            {versionNum: 'hhy20210825', updateNum: '2021年08月25日', src:'https://hhy.cargocn.com/download/hhypdf/hhy-0825.pdf', content: ['1、开票管理--新增发票回填及优化，开票日期可选择', '2、开票管理--批量发票回填导出及导入优化', '3、开票管理--开票申请，可以按运单数选择开票', '4、开票管理--选择结算单显示条数优化', '5、司机结算管理--页面司机支付金额与导出的表格不一致优化', '6、运单管理--运营端增加结算重量、收发货时间', '7、货主结算--修改优化，不设置修改原因时，显示请选择', '8、任务运单支付--增加同意、拒接、单笔支付、调整人员、重试、查询运单号、查询 车辆、结算单、客户单操作按钮', '9、网商异常处理--页面新增全选批量重试功能', '10、运营端-司机认证、车辆认证--切换页面后重置查询条件保留优化', '11、简化认证流程，方便司机操作', '12、增加预加载骨架，优化响应效率', '13、增加 我的--客户服务，点击客服展示客服电话和服务时间', '14、任务运单支付，增加可选择每页条数 ', '15、任务运单支付已分配待处理为空，修改为数值 0', '16、发货管理--自主派车和发布找车单价新增单位', '17、运单管理-车辆无法模糊搜索查询', '18、规模折让优化', '19、货主结算修改批导模板及修改原因', '20、开票申请页面添加上传附件功能']},
            {versionNum: 'hhy20210707', updateNum: '2021年07月07日', src:'https://hhy.cargocn.com/download/hhypdf/hhy-0707.pdf', content: ['1、货主结算--增加结算单批量查询功能', '2、运单管理--新增司机姓名、车牌号、收款人信息、建单时间筛选项', '3、司机支付和司机结算管理列表里，增加到达时间，结算量', '4、移动端--起运到达图片增加水印及优化', '5、发货管理--详情增加发布的司机价格', '6、审核中心可多条审核', '7、收款人管理，列表增加操作记录，渠道字段', '8、托运人资金账户导出，有重复记录', '9、网商异常处理-失败状态更新', '10、移动端--添加收款人时同步给公司的收款人数据中收款人认证状态已同步', '11、回单导出问题修复', '12、车辆管理优化', '13、司机 APP--证照到期增加消息提醒', '14、车辆司机企业认证', '15、发货管理--新增保险', '16、报表管理--司机支付流水报表和业务支付明细报表', '17、轨迹优化', '18、司机合同的签章样式', '19、运单详情增加货源编码信息，货源详情增加运单号信息', '20、分包业务无法手工处理磅单']},
            {versionNum: 'hhy20210609', updateNum: '2021年06月09日', src:'https://hhy.cargocn.com/download/hhypdf/hhy-0609.pdf', content: ['1、货主结算支持批量查询', '2、标准接口-把初次领证日期改成非必填', '3、新建运单时，未认证的车辆不可被选择到', '4、司机结算显示卸车量和到达时间', '5、司机结算新增是否开票的筛选', '6、运单管理支持修改起运和到达时间', '7、货管理货源新增发布价格', '8、运单管理建单时间支持输入时间', '9、司机管理和车辆管理新建时，支持输入托运方后带出承运方']},
            {versionNum: 'hhy20210526', updateNum: '2021年05月26日', src:'https://hhy.cargocn.com/download/hhypdf/hhy-0526.pdf', content: ['1、付款管理优化', '2、【天津、榆林】计税起征点同步调整到 15 万 ', '3、司机结算，装车量和卸车量可更改', '4、修复司机结算导出缺少收款人 2 支付状态的 bug', '5、司机 APP，卸货时，卸货重量默认空值，可填写', '6、业务支付统计报表新增司机支付金额', '7、发货管理页面新增货源来源，可筛选', '8、移动端，货源页面显示备注信息', '9、司机管理新增页面排版优化', '10、修复回单多张，税务上传模块图片无法显示的 bug', '11、运单管理新增车辆、司机、收款人筛选条件', '12、先结算的业务场景支持分包的货主结算单也提前生成', '13、采购登记的两个导出按钮可配置', '14、异常事件中的地址显示改为中文']},
            {versionNum: 'hhy20210512', updateNum: '2021年05月12日', src:'https://hhy.cargocn.com/download/hhypdf/hhy-0512.pdf', content: ['1、承运合同、司机协议可生成电子合同 ', '2、运单管理优化', '3、司机 APP 和小程序在起运和到达上传照片只可拍照不可图片选择', '4、对托运企业新增综合评分', '5、车辆管理优化', '6、司机管理优化 ', '7、财务收款优化 ', '8、修复司机支付流水报表有重复值的 bug ', '9、修复托运人资金账户导出缺少小数点的问题', '10、车辆带“挂”字的不可系统认证成功 ', '11、油气折让页面左下角添加汇总金额', '12、司机结算和司机支付页面添加起运时间和装车量', '13、修复收款管理重复登记的 bug']},
            {versionNum: 'hhy20210428', updateNum: '2021年04月28日', src:'https://hhy.cargocn.com/download/hhypdf/hhy-0428.pdf', content: ['1、基础管理中新增船舶和船员', '2、司机管理添加导出按钮', '3、司机结算页面添加回单的照片', '4、修复运单管理中客户单号不显示的 bug', '5、支付中心 bug 修复', '6、虚拟集团司机未同步 bug 修复', '7、司机结算单新增支付中状态', '8、托运端收款人管理新增查询条件身份证号', '9、司机 APP 小程序支持修改手机号', '10、货主结算单导出字段新增', '11、司机结算和司机支付查询条件重新排版']},
            {versionNum: 'hhy20210415', updateNum: '2021年04月15日', src:'https://hhy.cargocn.com/download/hhypdf/hhy-0415.pdf', content: ['1、货主结算页导出新增字段；权限开放托运方，权限可配', '2、司机结算和司机支付结果列表添加字段；修复 1000 条卡顿 bug', '3、快捷建单优化 ', '4、支付中心、审核中心权限 bug 修复', '5、运单删除逻辑优化', '6、虚拟集团新建-基础数据共享', '7、运单管理复制功能', '8、托运人打款账号添加托运人名称', '9、PC 端司机管理手机号支持编辑', '10、天津运单回单添加水印-交委需求', '11、移动端支持修改司机信息和车辆信息', '12、官网更新' ]},
        ]
    };
  },
  computed: {
    
  },
  activated(){
    this.activeName = 1; 
  },
  mounted() {
    this.activeName = 1; 
  },
  methods: {
    
  }
};
</script>

<style scoped>
.welcome {
  margin: 50px;
}
.content-box{
    display: flex;
    justify-content: space-between;
}
.version-btn{
    display: flex;
    align-items: flex-end;
}
.btn-img{
    width: 15px;
    height: 12px;
    margin-right: 5px;
}
.btn-box{
    display: flex;
    align-items: center;
    border: 1px solid #316DF4;
    color: #316DF4;
    padding: 0 5px;
    border-radius: 5px;
    font-size: 12px;
    text-decoration:none;
}
.version-background{
    position: fixed;
    bottom: 30px;
    right: 0;
    width: 50%;
    display: flex;
    justify-content: flex-end;
    z-index: -1;
}
.version-img{
    width: 60%;
    height: auto;
}
</style>



// WEBPACK FOOTER //
// src/page/version.vue